<template>
    <div class="error-banner" v-if="visible">
        <div class="toast-bar" />
        <img
        :src="InfoAlertIcon"
        alt="Alert"
        class="alert-icon"
        />
        <div class="toast-text">
        {{ message }}
        </div>
        <button class="toast-icon" @click="$emit('close')">
        <img :src="CloseIcon" alt="Close" />
        </button>
    </div>
</template>

<script setup lang="ts">
import InfoAlertIcon from "../../assets/images/InfoAlertRed.svg";
import CloseIcon from "../../assets/images/Close.svg";

defineProps<{
    message: string;
    visible: boolean;
}>();

defineEmits(["close"]);
</script>

<style scoped lang="scss">
.error-banner {
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.6rem;
    height: 5.6rem;
    border-radius: 0.8rem;
    width: 38.8rem;
    background-color: #f5dee2;
    padding: 0;

    .toast-bar {
        background-color: #b00020;
        width: 1rem;
        height: 100%;
        border-top-left-radius: 0.8rem;
        border-bottom-left-radius: 0.8rem;
    }

    .toast-text {
        font-size: 1.4rem;
        text-overflow: hidden;
        width: 27.2rem;
        color: #b00020;
        text-align: left;
    }

    .toast-icon {
        width: 2.4rem;
        height: 2.4rem;
        background-color: transparent;
        margin: 0;
        margin-right: 1.2rem;

        img {
        width: 1.6rem;
        height: 1.6rem;
        }
    }

    .alert-icon {
        margin: 0;
        width: 2.4rem;
        height: 2.4rem;
    }
}
</style>
